export const textSizeOptions = [
    { value: "h1", label: "Big header", size: "32px" },
    { value: "h2", label: "Medium header", size: "24px" },
    { value: "h3", label: "Small header", size: "18px" },
    { value: "text", label: "Text", size: "12px" },
    { value: "small", label: "Small text", size: "10px" }
];

export const getTextSizeFromHtml = (html) => {
    const match = textSizeOptions.find(option => option.value === html);

    if (match===undefined){
        return "text"
    } else {
        return match.value
    }
}

export const unwrap = (html) => {
    if (!html) return "";
    return html.replace(/^<div style="font-size:\s*\d+px">/, "").replace(/<\/div>$/, "");
}

export const wrap = (html, size) => {
    const foundOption = textSizeOptions.find(option => option.value === size);
    const fontSizePx = foundOption ? foundOption.size : "16px";

    return `<div style="font-size: ${fontSizePx}">${html}</div>`;
}